import { BuildModuleParamsType } from 'types/api-internal';
import { SugarMoneyApiMostRecentGamesResponseType } from 'types/games';

export const gamesModule = ({ makeApiRequest }: BuildModuleParamsType) => ({
  getRecent: async () =>
    makeApiRequest<SugarMoneyApiMostRecentGamesResponseType>({
      endpoint: 'games/recent',
      options: { method: 'get' },
    }),
});
